import {IconProp} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import React from 'react'
import {NavLink} from 'react-router-dom'
import {AuctionFilter, setAuctionFilter, SubjectType} from 'redux/actions'
import {history} from 'Router/Router'
import {connect} from 'react-redux'
import {GlobalState} from '../state'
import Trans from './Trans'

type NavigationItemProps = {
  filter?: string
  auctionFilter: AuctionFilter
  hideModal?: () => void
  visible?: boolean
  path?: string
  title?: string
  icon?: IconProp
  totalAuctions: number
  totalCount?: number
  subjectType: SubjectType
}

type NavigationItemState = {
  filter: string | undefined
}

class NavigationItem extends React.Component<NavigationItemProps, NavigationItemState> {
  constructor(props: NavigationItemProps) {
    super(props)
    this.state = {
      filter: this.props.filter
    }
  }

  changeFilter = async (filter: string | undefined) => {
    await this.setState({filter: filter})

    await setAuctionFilter(this.props.auctionFilter, {type: filter}, this.props.subjectType)

    this.props.hideModal && this.props.hideModal()

    history.push('/')
  }

  render() {
    return this.props.visible && (
      <div className='px-0 md:px-2'>
        {this.props.path ? (
          <NavLink to={this.props.path} onClick={() => this.props.hideModal && this.props.hideModal()} className="block text-gray-800 hover:bg-gray-300 hover:text-gray-800 rounded focus:text-gray-800 px-4 py-2 w-full text-center sm:text-left flex flex-col sm:flex-row items-center sm:items-left" activeClassName="bg-gray-300 hover:bg-gray-300 rounded" exact>
            {this.props.icon && <Icon icon={this.props.icon}/>}
            <span className="font-semibold pl-0 sm:pl-1 whitespace-no-wrap">
              <Trans>{this.props.title || ''}</Trans>
            </span>
          </NavLink>
        ) : typeof this.props.filter !== 'undefined' ?
          (
            <button onClick={() => this.changeFilter(this.props.filter)} className={'block text-gray-800 hover:bg-gray-300 hover:text-gray-800 rounded focus:text-gray-800 px-4 py-2 w-full text-center sm:text-left flex flex-col sm:flex-row items-center sm:items-left focus:outline-none active:outline-none' + (this.props.auctionFilter.type === this.state.filter && history.location.pathname === '/' ? ' bg-gray-300 hover:bg-gray-300 rounded' : '')}>
              {this.props.icon && <Icon icon={this.props.icon}/>}
              <span className="font-semibold pl-0 sm:pl-1 whitespace-no-wrap">
                <Trans>{this.props.title || ''}</Trans>

                {
                  this.props.filter === this.props.auctionFilter.type && this.props.totalCount ?
                    <span> ({this.props.totalAuctions})</span>
                    : null
                }
              </span>
            </button>
          )
          : (
            <div className="text-sm px-4 py-2 w-full text-center sm:text-left text-gray-700 mt-3 hidden md:block border-t border-gray-300">
              {this.props.icon && <Icon icon={this.props.icon}/>}

              <span className="font-semibold pl-0 sm:pl-1 whitespace-no-wrap"><Trans>{this.props.title || ''}</Trans></span>
            </div>
          )}
      </div>
    )
  }
}


export default connect((state: GlobalState) => ({
  auctionFilter: state.auctions.filter,
  totalAuctions: state.auctions.total,
  subjectType: state.app.subjectType
}))(NavigationItem)
